import React from "react";
import _ from "lodash";
import HeaderImage from "slides/components/HeaderImage.react";
import DividerIcon from "slides/components/DividerIcon";
import Question from "slides/components/Question.react";
import Separator from "slides/components/Separator.react";

export default class DefaultPortrait extends React.Component {
    render() {
        let backgroundImage = _.find(this.props.deck.images, {
            id: this.props.background,
        });
        let headerStyle = {};
        let pageStyle = {
            backgroundImage: `url(${
                backgroundImage ? backgroundImage.image : ""
            })`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            height: "100%",
        };
        let defaultStyle = {
            margin: "30px",
            textAlign: "center",
        };
        return (
            <div style={pageStyle}>
                <div style={headerStyle}>
                    <HeaderImage {...this.props} />
                    <DividerIcon
                        {...this.props}
                        icon={""}
                        keyNames={[
                            "divider-" + this.props.slideId,
                            "icon-" + this.props.slideId,
                        ]}
                        animation="transition.bounceLeftIn,500,transition.expandIn,750"
                    />
                </div>
                <div style={defaultStyle}>
                    <Question {...this.props} />
                    <Separator
                        keyName="separator"
                        color={this.props.colors.primary}
                        animation="fadeIn,100"
                    />
                    {this.props.mainContent}
                </div>
            </div>
        );
    }
}
